/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoExportComponent extends NestedOption {
    
    get backgroundColor(): string {
        return this._getOption('backgroundColor');
    }
    set backgroundColor(value: string) {
        this._setOption('backgroundColor', value);
    }

    
    get enabled(): boolean {
        return this._getOption('enabled');
    }
    set enabled(value: boolean) {
        this._setOption('enabled', value);
    }

    
    get fileName(): string {
        return this._getOption('fileName');
    }
    set fileName(value: string) {
        this._setOption('fileName', value);
    }

    
    get formats(): Array<string> {
        return this._getOption('formats');
    }
    set formats(value: Array<string>) {
        this._setOption('formats', value);
    }

    
    get printingEnabled(): boolean {
        return this._getOption('printingEnabled');
    }
    set printingEnabled(value: boolean) {
        this._setOption('printingEnabled', value);
    }

    
    get proxyUrl(): string {
        return this._getOption('proxyUrl');
    }
    set proxyUrl(value: string) {
        this._setOption('proxyUrl', value);
    }

    
    get allowExportSelectedData(): boolean {
        return this._getOption('allowExportSelectedData');
    }
    set allowExportSelectedData(value: boolean) {
        this._setOption('allowExportSelectedData', value);
    }

    
    get excelFilterEnabled(): boolean {
        return this._getOption('excelFilterEnabled');
    }
    set excelFilterEnabled(value: boolean) {
        this._setOption('excelFilterEnabled', value);
    }

    
    get excelWrapTextEnabled(): boolean {
        return this._getOption('excelWrapTextEnabled');
    }
    set excelWrapTextEnabled(value: boolean) {
        this._setOption('excelWrapTextEnabled', value);
    }

    
    get texts(): any {
        return this._getOption('texts');
    }
    set texts(value: any) {
        this._setOption('texts', value);
    }

    protected get _optionPath() {
        return 'export';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-export',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'backgroundColor': [{ type: Input },],
'enabled': [{ type: Input },],
'fileName': [{ type: Input },],
'formats': [{ type: Input },],
'printingEnabled': [{ type: Input },],
'proxyUrl': [{ type: Input },],
'allowExportSelectedData': [{ type: Input },],
'excelFilterEnabled': [{ type: Input },],
'excelWrapTextEnabled': [{ type: Input },],
'texts': [{ type: Input },],
};
}


export class DxoExportModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoExportComponent
  ],
  exports: [
    DxoExportComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
